import { SHOW_FLYOUT, HIDE_FLYOUT, SHOW_ALERT, HIDE_ALERT, SET_FLYOUT_TITLE } from './actionTypes';

const flyoutInitialState = {
  show: false,
  target: '',
  title: '',
};

const alertInitialState = {
  show: false,
  message: '',
  color: 'info',
};

const alertReducer = (
  state = alertInitialState,
  { type = '', props = { ...alertInitialState } } = {},
) => {
  switch (type) {
    case SHOW_ALERT:
      return {
        ...state,
        ...props,
        show: true,
      };

    case HIDE_ALERT:
      return {
        ...state,
        show: false,
      };

    default:
      return state;
  }
};

const flyoutReducer = (state = flyoutInitialState, { type = '', target = '', title = '' } = {}) => {
  switch (type) {
    case SHOW_FLYOUT:
      return {
        ...state,
        show: true,
        target,
      };

    case HIDE_FLYOUT:
      return {
        ...state,
        show: false,
        target,
      };

    case SET_FLYOUT_TITLE:
      return {
        ...state,
        title,
      };

    default:
      return state;
  }
};

export { flyoutReducer, alertReducer, alertInitialState };
